export default function (alias) {
  if (alias) {
    return alias.toLowerCase().replace(/-|\s/g, '').startsWith('multishare')
  }
  return false
}